export const MOBILE_EVENTS = new Set([
  'mobile_product_view', 'buy_click', 'offer_click', 'offer_start', 'select_size',
  'drawer_open', 'drawer_close', 'size_continue', 'offer_price_confirmed', 'validation_failed',
  'seller_entry_click', 'seller_size_selected', 'seller_action_click',
  'checkout_started', 'checkout_step_view', 'checkout_step_complete', 'checkout_back',
  'checkout_close', 'checkout_resume', 'checkout_viewport_change',
  'email_submit_click', 'guest_email_submitted', 'email_send_failed',
  'otp_verify_click', 'otp_resend_clicked', 'otp_resend_succeeded', 'otp_resend_failed',
  'guest_otp_verified', 'guest_otp_failed', 'address_continue_click', 'address_change_click',
  'address_search_used', 'address_suggestion_click', 'location_click', 'location_result',
  'delivery_quote_state', 'delivery_quote_retry', 'payment_method_selected',
  'saved_card_selected', 'add_card_click', 'save_card_click', 'card_method_created',
  'card_add_failed', 'place_order_click', 'place_offer_click', 'payment_retry_click',
  'checkout_error_shown', 'checkout_result_view', 'support_click', 'product_details_toggle'
]);
const KEYS = new Set(['item_id','size_id','size_system','currency','checkout_mode','step',
  'from_step','to_step','drawer','action','reason','field','method','availability','value',
  'preview','guest','logged_in','has_saved_address','selected','status','attempt_number']);
function clean(input) {
  return Object.fromEntries(Object.entries(input || {}).filter(([key,value]) =>
    KEYS.has(key) && (typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value)) ||
      (typeof value === 'string' && value.length <= 80 && !/[\r\n@]/.test(value)))));
}
export function environment(host) {
  return ['houseofstox.com','www.houseofstox.com'].includes(host) ? 'production' : 'nonproduction';
}
// Only explicit, non-identifying properties cross this boundary.
export function createMobileAnalytics({send, context, host, viewport, id, now = Date.now}) {
  const started = now();
  const once = new Set();
  let extra = {};
  const emit = (event, props = {}) => {
    if (!MOBILE_EVENTS.has(event)) return;
    try {
      send(event, {...clean(context()), ...clean(extra), ...clean(props),
        tracking_version: 'mobile_clicks_v1', surface: 'mobile_checkout',
        checkout_attempt_id: id, hostname: host, environment: environment(host),
        viewport: viewport() < 768 ? 'mobile' : 'desktop',
        elapsed_ms: Math.max(0, now() - started)});
    } catch { /* Analytics must not interrupt shopping. */ }
  };
  emit.context = (props) => { extra = {...extra, ...clean(props)}; };
  emit.once = (key, event, props) => { if (!once.has(key)) { once.add(key); emit(event, props); } };
  return emit;
}
